import * as React from "react"
// import parse from 'html-react-parser'

const GRMbanner = (props) => {
    // let { bannerData, bannerImage } = props
    // let bgImage = "url('" + bannerImage + "')"
    // let regex = /(<([^>]+)>)/ig
    // let pageName = bannerData.bannerText.replace(regex, ' ')

    return(
        <>
            
        </>
    )
}

export default GRMbanner;
